import { render, staticRenderFns } from "./CurriculumEditing.vue?vue&type=template&id=5f77d65c&scoped=true&lang=pug"
import script from "./CurriculumEditing.vue?vue&type=script&lang=js"
export * from "./CurriculumEditing.vue?vue&type=script&lang=js"
import style0 from "./CurriculumEditing.vue?vue&type=style&index=0&id=5f77d65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f77d65c",
  null
  
)

export default component.exports